var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"scrollView",staticClass:"scroll-view",on:{"scroll":_vm.handleScroll}},[_c('div',{staticClass:"scroll-view-content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }